<template>
  <div @click="$emit('edit')" class="itemEdit">
    <span class="itemEditText">
      {{ $t(`order.btn.edit`) }}
    </span>
  </div>
</template>
<script>
export default {
  name: "EditButton"
};
</script>
<style>
.itemEdit {
  align-items: center;
  background: var(
    --component_order_listitems_common_editButton_itemEdit_background
  );
  background-repeat: no-repeat;
  background-image: var(
    --component_order_listitems_common_editButton_itemEdit_background-image
  );
  background-position: 6px 5px;
  color: var(--component_order_listitems_common_editButton_itemEdit_color);
  display: flex;
  font-family: var(
    --component_order_listitems_common_editButton_itemEdit_font-family
  );
  font-size: var(
    --component_order_listitems_common_editButton_itemEdit_font-size
  );
  height: 35px;
  justify-content: center;
  left: 900px;
  margin: 0 15px 0 0;
  padding: 0 15px 0 35px;
  pointer-events: all;
}

.itemEditText {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
